import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { configure_getting_started_progress } from "../../../actions/globalAction";
import "./content.scss";
import { Link } from "react-router-dom";
import { Dimmer, Loader } from "semantic-ui-react";
import { ReactComponent as AssetLibraryIcon } from "../../../assets/svg/asset-library.svg";
import { setActiveModule } from "../../../actions/sideBarActions";

const AssetLibrary = () => {
    const dispatch = useDispatch();
    // useEffect(() => {
    //     let obj = {
    //         // total_sections: 33,
    //         progress_config: {
    //             asset_library: 1,
    //         },
    //     };
    //     dispatch(configure_getting_started_progress(obj));
    // }, []);
    const configureProgress = () => {
        let obj = {
            // total_sections: 33,
            progress_config: {
                asset_library: 1,
            },
        };
        localStorage.setItem("activeModule", "Publishing");
        dispatch(setActiveModule("Publishing"));
        dispatch(configure_getting_started_progress(obj));
    };
    return (
        <>
            <div className="gs_content">
                <div className="left_content">
                    <div className="gs_header">
                        {/* <Icon name="user" size="large" className="icon_content" color="#268af6" width="20px" height="20px" /> */}
                        <AssetLibraryIcon className="icon_content fill_svg" />
                        <span className="content_title">Asset Library</span>
                    </div>
                    <div className="text_content">
                        <p>{`Asset Library is where you store all your media like images and videos that you would like to use in your posts.  `}</p>
                        <p>Content has to be first uploaded to the asset library before it can be used in any of your posts.</p>
                        {/* <p>{`Some of the reports and other functionality use your time zone to work properly.  You can control your time zone from here.`}</p> */}
                    </div>
                    <Link to="/social-media-publishing/assets">
                        <button className="gs_link" onClick={() => configureProgress()}>
                            Explore
                        </button>
                    </Link>
                </div>
                <div className="right_content">
                    <div id="gs_loader">
                        <Dimmer inverted active>
                            <Loader size="big skiptranslate">Loading</Loader>
                        </Dimmer>
                    </div>
                    <iframe
                        width="320px"
                        height="200px"
                        src="https://www.youtube.com/embed/P1ul-_n7MpM"
                        title=""
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; gyroscope; picture-in-picture"
                        allowFullScreen
                        onLoad={() => (document.getElementById("gs_loader").style.display = "none")}
                        className="content_video"></iframe>
                    {/* <img className="content-img" src={profileImg} width="350px" height="200px" /> */}
                </div>
            </div>
        </>
    );
};

export default AssetLibrary;
